// removed by extract-text-webpack-plugin
module.exports = {"error":"WaitingRoomSetting-error"};